import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconSwitchAppOutline } from '@saucelabs/ds-icons';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import { MANUAL_TEST_EVENTS, trackEvent } from '../../../tracking';
import {
  constants as switchAppVersionConstants,
  FilesModal as SwitchAppVersionModal,
} from '../../switchAppVersion';
import selectors from '../selectors';
import GenericButton from './GenericButton';

const SwitchAppVersionButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceDescriptor,
    deviceToolsDisabled,
  } = useSelector(selectors.toolbarButtonSelector);

  const showSwitchAppVersionModal = () => {
    void dispatch(modalActions.showModal(switchAppVersionConstants.MODAL_KEY));

    trackEvent(MANUAL_TEST_EVENTS.SHOW_SWITCH_APP_VERSION, {
      deviceName: deviceDescriptor.name,
      os: deviceDescriptor.os,
    });
  };

  return (
    <>
      <SwitchAppVersionModal />

      <GenericButton
        dataQa="live-session-toolbar-switch-app-version-button"
        disabled={deviceToolsDisabled}
        icon={IconSwitchAppOutline}
        label="Switch App Version"
        onPress={showSwitchAppVersionModal}
        role={role}
      />
    </>
  );
};

SwitchAppVersionButton.displayName = 'SwitchAppVersionButton';

export default SwitchAppVersionButton;
